import axios from 'axios';

const hostelBed = {
    namespaced: true,
    
	actions: {		
		ProcessHostelBed(context, userdata){
			return new Promise((resolve, reject) => {				
				axios({url: '/HostelBed/ProcessHostelBed', data: userdata, method: 'POST' })
				.then(resp => resp.data)
				.then(respdata => {									
					resolve(respdata)
				})
				.catch(err => {
					reject(err)
				})
			})
		}, 		
		GetHostelBed({rootState},RoomId){
			return new Promise((resolve, reject) => {				
				axios.get(`/HostelBed/GetHostelBed?RoomId=${RoomId}&Username=${rootState.auth.username}&Accesskey=${rootState.auth.accesskey}`)
				.then(resp => resp.data)
				.then(respdata => {									
					resolve(respdata)
				})
				.catch(err => {
					reject(err)
				})
			})
		}, 
		GetByIdHostelBed({rootState},{RoomId,Id}){
			return new Promise((resolve, reject) => {				
				axios.get(`/HostelBed/GetByIdHostelBed?Id=${Id}&RoomId=${RoomId}&Username=${rootState.auth.username}&Accesskey=${rootState.auth.accesskey}`)
				.then(resp => resp.data)
				.then(respdata => {									
					resolve(respdata)
				})
				.catch(err => {
					reject(err)
				})
			})
		}
	}
}

export default hostelBed